import type { ScreenBase } from "@frui.ts/screens";
import { ConductorOneChildActive, Router } from "@frui.ts/screens";
import { Modules } from "config";
import { computed } from "mobx";
import LocalizationService from "services/localizationService";
import SecurityService from "services/securityService";
import EventBus from "../../../services/eventBus";
import type { IModuleViewModel } from "../../types";
import BalanceViewModel from "./balance/balanceViewModel";
import DocumentsInventoryViewModel from "./documentsInventory/documentsInventoryViewModel";

const navigationName = "accounting";

@Router.registerRoute({
  route: navigationName,
  name: Router.Self,
  children: [BalanceViewModel, DocumentsInventoryViewModel],
})
export default class InventoryViewModel extends ConductorOneChildActive<ScreenBase> implements IModuleViewModel {
  showChildrenSubmenu = true;

  private unsubscriptions: Array<() => void> = [];

  @computed
  get name() {
    return this.translate("name");
  }

  constructor(
    private localizationService: LocalizationService,
    private balanceViewModel: BalanceViewModel,
    private documentsInventoryViewModel: DocumentsInventoryViewModel,
    private securityService: SecurityService,
    protected eventBus: EventBus
  ) {
    super();
    this.navigationName = navigationName;

    if (this.securityService.allowTo("finance")) {
      this.children.push(this.documentsInventoryViewModel);
    }

    if (this.securityService.allowTo("finance")) {
      this.children.push(this.balanceViewModel);
    }
  }

  protected onInitialize(): Promise<any> | void {
    if (!this.activeChild) {
      this.tryActivateChild(this.children[0]);
    }

    return super.onInitialize();
  }

  protected onDeactivate(isClosing: boolean): Promise<void> {
    if (isClosing) {
      this.unsubscriptions.forEach(unsubscribe => unsubscribe());
      this.unsubscriptions = [];
    }
    return super.onDeactivate(isClosing);
  }

  closeChild(child: ScreenBase) {
    return false;
  }

  translate(code: string, size?: number) {
    return this.localizationService.translateModule(Modules.finance, `inventory.${code}`, size);
  }
}
